import { Component, inject, Injector, ChangeDetectionStrategy } from "@angular/core";
import { ReadonlyAccessWidget } from "../../readonly-access/readonly-access.widget";
import { AccApplicationDialogDataService } from "../acc-application-dialog-data.service";
import { EditStatusLogPart } from './edit-status-log/edit-status-log.part';
import { StatusLogListPart } from './status-log-list/status-log-list.part';

@Component({
	selector: 'acc-application-status-log-dialog-part',
	standalone: true,
	imports: [
		ReadonlyAccessWidget,
		StatusLogListPart,
		EditStatusLogPart
	],
	templateUrl: './status-log-dialog.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './status-log-dialog.part.scss'
})
export class StatusLogDialogPart {

	public accAppDialogDataService = inject(AccApplicationDialogDataService);

}